// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ORVvRY{position:relative;height:inherit;opacity:0;visibility:hidden;transition:opacity 0.3s ease-in-out;max-width:0;max-height:0;overflow:hidden}.ORVvRY.Idrne8{max-width:none;max-height:none;opacity:1;visibility:visible}.zzGT0Q{position:relative;height:inherit;opacity:0;visibility:hidden;transition:opacity 0.3s ease-in-out;max-width:0;max-height:0;overflow:hidden;transition:visibility 0s 0.3s, opacity 0.3s;transition-timing-function:ease-in-out}.zzGT0Q.Idrne8{max-width:none;max-height:none;opacity:1;visibility:visible}.zzGT0Q.Idrne8{max-width:none;max-height:none;opacity:1;visibility:visible;transition-delay:0s}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fade-in": `ORVvRY`,
	"fadeIn": `ORVvRY`,
	"active": `Idrne8`,
	"fade-in-out": `zzGT0Q`,
	"fadeInOut": `zzGT0Q`
};
export default ___CSS_LOADER_EXPORT___;
